export interface Grecaptcha {
    render: (container: string | HTMLElement, parameters: { sitekey?: string }) => number;
    getResponse: (widgetId?: number) => string;
}

declare global {
    interface Window {
        grecaptcha?: Grecaptcha;
        onRecaptchaLoad?: () => void;
    }
}

let recaptchaPromise: Promise<Grecaptcha> | undefined;

/**
 * Injects the reCAPTCHA script once and waits until the api is ready to render widgets.
 * @returns The grecaptcha api, shared by every caller
 */
export function loadRecaptcha(): Promise<Grecaptcha> {
    if (recaptchaPromise) return recaptchaPromise;

    recaptchaPromise = new Promise<Grecaptcha>((resolve, reject) => {
        window.onRecaptchaLoad = () => {
            if (window.grecaptcha) resolve(window.grecaptcha);
            else reject(new Error("reCAPTCHA loaded without grecaptcha"));
        };

        const script = document.createElement("script");
        script.src = "https://www.recaptcha.net/recaptcha/api.js?render=explicit&onload=onRecaptchaLoad";
        script.async = true;
        script.onerror = () => {
            recaptchaPromise = undefined;
            script.remove();
            reject(new Error("Failed to load reCAPTCHA"));
        };
        document.head.appendChild(script);
    });

    return recaptchaPromise;
}
